import { render, staticRenderFns } from "./SmsInboundBubble.vue?vue&type=template&id=123c90ea&scoped=true&"
import script from "./SmsInboundBubble.vue?vue&type=script&lang=ts&"
export * from "./SmsInboundBubble.vue?vue&type=script&lang=ts&"
import style0 from "./SmsInboundBubble.vue?vue&type=style&index=0&id=123c90ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123c90ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VHover,VIcon,VRow})
